import { ReactNode, useEffect, useRef, useCallback } from 'react';
import { throttle } from 'throttle-debounce';

import { useOnIntersection } from '../../utils';

export interface IUseOldStickyProps {
  onBottomStuck?: (isIntersecting: boolean) => void;
  onTopStuck?: (isIntersecting: boolean) => void;
  children: ReactNode;
}

export const THROTTLE_DELAY = 100;
export const EVENTS = ['scroll', 'resize'];

export const useOldStickyProps = (props: IUseOldStickyProps) => {
  const { onBottomStuck, onTopStuck, children } = props;
  const sentinelRef = useRef<HTMLDivElement | null>(null);
  const onIntersection = useOnIntersection({ onBottomStuck, onTopStuck });
  const computeIsSticky = useCallback(() => {
    if (sentinelRef.current) {
      const sentinelClientRect = sentinelRef.current.getBoundingClientRect();
      onIntersection(sentinelClientRect);
    }
  }, [onIntersection]);

  // NOTE: необходимо для определения положения при инициализации
  useEffect(() => {
    if (children) {
      computeIsSticky();
    }
  }, [computeIsSticky, children]);

  useEffect(() => {
    const throttledComputing = throttle(THROTTLE_DELAY, computeIsSticky);
    EVENTS.forEach(event => window.addEventListener(event, throttledComputing));

    return () => {
      EVENTS.forEach(event => window.removeEventListener(event, throttledComputing));
    };
  }, [computeIsSticky]);

  return { sentinelRef };
};
